"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TagSet_1 = require("./_TagSet");
exports._AnalyticsAndOperator = {
    type: "structure",
    required: [],
    members: {
        Prefix: {
            shape: {
                type: "string"
            }
        },
        Tags: {
            shape: _TagSet_1._TagSet,
            flattened: true,
            locationName: "Tag"
        }
    }
};
//# sourceMappingURL=_AnalyticsAndOperator.js.map